export enum ContractAddress {
    address = '0x4f4334d1a0bf96492633d1e22c531e54fcab7b72',
}